export default "__VITE_ASSET__DXMkBhGG__"